import { render, staticRenderFns } from "./ComunicationsView.vue?vue&type=template&id=15eea28e&scoped=true&lang=pug&"
import script from "./ComunicationsView.vue?vue&type=script&lang=js&"
export * from "./ComunicationsView.vue?vue&type=script&lang=js&"
import style0 from "./ComunicationsView.vue?vue&type=style&index=0&id=15eea28e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15eea28e",
  null
  
)

export default component.exports